import { FormContainer, notify } from '@wyz/ui';
import clsx from 'clsx';
import { memo } from 'react';
import { useForm } from 'react-hook-form';
import { Trans } from '~/common/context';
import { usePurchaseErrorTranslation } from '~/common/hooks';
import { IUserCustomer } from '~/common/types';
import { useManageWcwCart } from '~/purchase/api';
import { PurchaseTable, WcwOfferRow } from '~/purchase/components';
import { WcwCartHelpers } from '~/purchase/helpers';
import { IWcwOffer } from '~/purchase/types';

type Props = {
  product: IWcwOffer;
  customer: IUserCustomer;
  viewPrice: boolean;
};

function WcwTyreGroupRow({ product, customer, viewPrice }: Props) {
  const wcwCart = useManageWcwCart({
    context: { customerId: customer.id },
    add: { enabled: true },
  });
  const methods = useForm({
    defaultValues: {
      quantity: product.offers.map(() => product.wheel.salesUnit),
    },
  });
  const { resolveErrorKey } = usePurchaseErrorTranslation();

  return (
    <FormContainer
      methods={methods}
      id={product.id}
      submitHandler={() => {
        wcwCart.add.mutate(WcwCartHelpers.prepareAddWcwCartPayload(product), {
          onSuccess: () => {
            notify.success(
              <Trans i18nKey='app.purchase.cart.success.order' />,
              { id: 'toast-success-wcw-cart-add-to-cart' },
            );
          },
          onError: (error) => {
            notify.error(
              <Trans
                i18nKey={resolveErrorKey(error.message)}
                values={error?.meta}
              />,
            );
          },
        });
      }}
    >
      <PurchaseTable
        className={clsx('wcw-table', !viewPrice && 'wcw-table--hide-price')}
      >
        <tbody>
          {product.offers.map((offer, offerIndex) => (
            <WcwOfferRow
              key={`${product.id}-${offer.supplier.id}-${offerIndex}`}
              product={product}
              offer={offer}
              offerIndex={offerIndex}
              offersCount={product.offers.length}
              showCommon={offerIndex === 0}
              viewPrice={viewPrice}
              isAdding={wcwCart.add.isLoading}
            />
          ))}
        </tbody>
      </PurchaseTable>
    </FormContainer>
  );
}

export default memo(WcwTyreGroupRow);
